var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({class:_vm.svgClass,style:({width: _vm.size + 'px', height: _vm.size + 'px', fill: _vm.fill}),attrs:{"aria-hidden":"true"}},_vm.$listeners),[_c('title',[_vm._v(_vm._s(_vm.title))]),_c('use',{attrs:{"xlink:href":_vm.iconName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }